// Configuration for the admin portal
export const config = {
  // AppSync GraphQL endpoint
  graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'https://your-appsync-endpoint.appsync-api.region.amazonaws.com/graphql',
  
  // AWS configuration for S3 uploads and Cognito authentication
  aws: {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-2',
    s3Bucket: process.env.REACT_APP_S3_BUCKET || 'your-s3-bucket-name',
    identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID || '',
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID || '',
    hostedUIUrl: process.env.REACT_APP_AWS_HOSTED_UI_URL || '',
  }
};

// Note: For production, consider using AWS Cognito for authentication
// instead of environment variables for AWS credentials
